/**
 * perfect-scrollbar marks drag thumbs as focusable and button-like elements.
 * These thumbs are purely pointer drag affordances and should be hidden from AT.
 *
 * @param {ParentNode | null | undefined} root - Ancestor of the .ps element (e.g. CustomScrollbar root or Login root).
 */
export function stripPerfectScrollbarThumbTabindex(root) {
  if (!root?.querySelectorAll) return
  root.querySelectorAll(".ps__thumb-x, .ps__thumb-y").forEach((el) => {
    // Keep mouse drag behavior while preventing false button semantics in audits.
    el.setAttribute("tabindex", "-1")
    el.removeAttribute("role")
    el.removeAttribute("aria-label")
    el.setAttribute("aria-hidden", "true")
  })
}
